import * as Yup from "yup";

export const validation = Yup.object().shape({
  email: Yup.string()
    .email("Introduzca un email válido.")
    .nullable("Campo requerido"),
  operador: Yup.string().required("Campo requerido.").nullable(),
});
